import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/styles.css';
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function EmployerDashboard(props) {
  document.title = props.title;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userEmployerDetailsLog'));


  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);

  const [userOrganizationName, setUserOrganizationName] = useState("");
  const [userOrganizationAddress, setUserOrganizationAddress] = useState("");
  const [userOrganizationEmail, setUserOrganizationEmail] = useState("");
  const [userOrganizationPhoneNumber, setUserOrganizationPhoneNumber] = useState("");
  const [userOrganizationWebsiteLink, setUserOrganizationWebsiteLink] = useState("");
  const [userTypeOfOrganization, setUserTypeOfOrganization] = useState("");
  const [userOrganizationOtherType, setUserOrganizationOtherType] = useState("");
  const [userYourName, setUserYourName] = useState("");
  const [userYourOfficialEmail, setUserYourOfficialEmail] = useState("");
  const [userYourPhoneNumber, setUserYourPhoneNumber] = useState("");
  const [userYourDesignationInTheOrganization, setUserYourDesignationInTheOrganization] = useState("");
  const [userWhichOfOurStudentsAreHired, setWhichOfOurStudentsAreHired] = useState("");
  const [userBrieflyDescribeYourOrganization, setUserBrieflyDescribeYourOrganization] = useState("");
  const [submittedFeedbackDetails, setSubmittedFeedbackDetails] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    getEmployerPersonalDetails();
  }, []);

  function onTakeUpSurveyClick() {
    if (userOrganizationName) {
      if (userOrganizationAddress) {
        if (userOrganizationEmail) {
          if (userOrganizationPhoneNumber) {
            if (userOrganizationWebsiteLink) {
              if (userTypeOfOrganization) {
                if (userYourName) {
                  if (userYourOfficialEmail) {
                    if (userYourPhoneNumber) {
                      if (userYourDesignationInTheOrganization) {
                        if (userWhichOfOurStudentsAreHired) {
                          axios.post(config.API_URL + 'updateEmployerPersonalDetails', {
                            userId: userLoginDetails.alr_auto_id,
                            organizationName: userOrganizationName,
                            organizationAddress: userOrganizationAddress,
                            organizationEmail: userOrganizationEmail,
                            orgnizationPhoneNumber: userOrganizationPhoneNumber,
                            organizationWebsiteLink: userOrganizationWebsiteLink,
                            organizationType: userTypeOfOrganization,
                            otherOrganizationName: userOrganizationOtherType,
                            name: userYourName,
                            officialEmailId: userYourOfficialEmail,
                            mobileNumber: userYourPhoneNumber,
                            designationInOrganization: userYourDesignationInTheOrganization,
                            studentHeiringQualification: userWhichOfOurStudentsAreHired,
                            organizationBreifIntro: userBrieflyDescribeYourOrganization
                          }, {
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                          }).then(function (response) {
                            if (response.data.status.status == 1) {
                              // console.log("response.data ----->", userLoginDetails);
                              userLoginDetails['userName'] = userYourName;
                              localStorage.setItem('userEmployerDetailsLog', JSON.stringify(userLoginDetails));
                              navigate('/EmployerFeedback');
                            }
                          }).catch(function (error) {
                            toast.error(error);
                          });
                        } else {
                          toast.error("Select Which of our students are hired in your organization?");
                        }
                      } else {
                        toast.error("Enter your designation in the organization");
                      }
                    } else {
                      toast.error("Enter your phone number");
                    }
                  } else {
                    toast.error("Enter your official email");
                  }
                } else {
                  toast.error("Enter your name");
                }
              } else {
                toast.error("Select type of organization");
              }
            } else {
              toast.error("Enter organization website link");
            }
          } else {
            toast.error("Enter organization phone number");
          }
        } else {
          toast.error("Enter organization email");
        }
      } else {
        toast.error("Enter organization address");
      }
    } else {
      toast.error("Enter organization name");
    }
  }

  function getEmployerPersonalDetails() {
    axios.post(config.API_URL + 'getEmployerPersonalDetails', {
      inputUserId: userLoginDetails.alr_auto_id
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      // console.log('getEmployerPersonalDetails', response.data.data);
      if (response.data.status.status == 1) {
        setUserOrganizationName(response.data.data[0].empr_organization_name);
        setUserOrganizationAddress(response.data.data[0].empr_organization_address);
        setUserOrganizationEmail(response.data.data[0].empr_organization_email_id);
        setUserOrganizationPhoneNumber(response.data.data[0].empr_organization_phone_number);
        setUserOrganizationWebsiteLink(response.data.data[0].empr_organization_website_link);
        setUserTypeOfOrganization(response.data.data[0].empr_organization_type);
        setUserOrganizationOtherType(response.data.data[0].empr_other_organization_name);
        setUserYourName(response.data.data[0].empr_name);
        setUserYourOfficialEmail(response.data.data[0].empr_official_emp_email_id);
        setUserYourPhoneNumber(response.data.data[0].empr_mobile_number);
        setUserYourDesignationInTheOrganization(response.data.data[0].empr_disignation_in_oraganization);
        setWhichOfOurStudentsAreHired(response.data.data[0].empr_student_hirering_qualification);
        setUserBrieflyDescribeYourOrganization(response.data.data[0].empr_briefly_organization_intro);
        setSubmittedFeedbackDetails(response.data.data[0].empr_submitted_feedback_bit);
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/Employer');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userYourName ? userYourName : ' Sir / Madam'}</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Employer Feedback</div>
          </div>
          </div>
        </section>

        <section className='section-userInformation'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='note note-thankyou'>
                <span style={{ display: 'block', marginBottom: '10px' }}>Dear {userYourName ? userYourName : ' Sir / Madam'},  </span>Thank you for employing students who have studied in {config.collegeName}. We are seeking feedback from employers about our graduates and or post graduates students employed with you.</div>
            </div>
          </div>
          <div className='row'>

            <div className="form-group col-md-4">
              <label htmlFor="exampleInputName">Organization's name <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userOrganizationName} placeholder="Enter Organization's name" onChange={(e) => setUserOrganizationName(e.target.value)} />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="exampleInputName">Address of the organization <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userOrganizationAddress} placeholder="Enter address of the organization" onChange={(e) => setUserOrganizationAddress(e.target.value)} />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="exampleInputName">Organizational E-Mail <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userOrganizationEmail} placeholder="Enter organizational e-mail" onChange={(e) => setUserOrganizationEmail(e.target.value)} />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="exampleInputName">Organizational phone number <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userOrganizationPhoneNumber} placeholder="Enter organizational phone number" onChange={(e) => setUserOrganizationPhoneNumber(e.target.value)} />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="exampleInputName">Organization website link <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userOrganizationWebsiteLink} placeholder="Enter organization website link" onChange={(e) => setUserOrganizationWebsiteLink(e.target.value)} />
            </div>

            <div className="form-group  col-md-4">
              <label htmlFor="">Type of organization <em>*</em></label>
              <select name="appointment" className="form-control" value={userTypeOfOrganization} onChange={(e) => setUserTypeOfOrganization(e.target.value)}>
                <option value="">-- Select--</option>
                <option value="Government">Government </option>
                <option value="Corporate">Corporate  </option>
                <option value="NGO">NGO </option>
                <option value="Bilateral Agency">Bilateral Agency </option>
                <option value="Social Enterprise">Social Enterprise </option>
                <option value="Other">Any other (specify)  </option>
              </select>
            </div>

            <div className="form-group col-md-12">
              {
                userTypeOfOrganization == "Other" ?
                  <>
                    <label htmlFor="exampleInputName">Other Type of organization</label>
                    <input type="text" className="form-control" id="exampleInputName" defaultValue={userOrganizationOtherType} placeholder="Enter other type of organization" onChange={(e) => setUserOrganizationOtherType(e.target.value)} />
                  </>
                  : ""
              }
            </div>

            <div className="form-group col-md-4">
              <label for="name">Your Name<span style={{ fontSize: '10px', fontWeight: 'normal' }}> (Person filling the form on behalf of organization)</span> <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userYourName} placeholder="Enter your name" onChange={(e) => setUserYourName(e.target.value)} />
            </div>

            <div className="form-group col-md-4">
              <label for="name">Your official email <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userYourOfficialEmail} placeholder="Enter your official email" onChange={(e) => setUserYourOfficialEmail(e.target.value)} />
            </div>

            <div className="form-group col-md-4">
              <label for="name">Your phone number <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userYourPhoneNumber} placeholder="Enter your phone number" onChange={(e) => setUserYourPhoneNumber(e.target.value)} />
            </div>

            <div className="form-group col-md-6">
              <label for="name">Your designation in the organization <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userYourDesignationInTheOrganization} placeholder="Enter designation in the organization" onChange={(e) => setUserYourDesignationInTheOrganization(e.target.value)} />
            </div>

            <div className="form-group  col-md-6">
              <label htmlFor="">Select Which of our students are hired in your organization? <em>*</em></label>
              <select name="appointment" className="form-control" value={userWhichOfOurStudentsAreHired} onChange={(e) => setWhichOfOurStudentsAreHired(e.target.value)}>
                <option value="">-- Select--</option>
                <option value="Undergraduate (UG)">Undergraduate (UG) </option>
                <option value="Postgraduate (PG)">Postgraduate (PG) </option>
                <option value="Both">Both</option>
              </select>
            </div>

            <div class="form-group col-md-12">
              <label for="name">Briefly describe your organizations key areas of work (in 50 words) </label>
              <textarea style={{ padding: '10px', resize: 'none' }} id="textarea1" placeholder="Briefly describe your organizations key areas of work (in 50 words)" defaultValue={userBrieflyDescribeYourOrganization} class="textarea" rows="2" onChange={(e) => setUserBrieflyDescribeYourOrganization(e.target.value)}></textarea>
            </div>

          </div>

          <div className='row'>
            <div className='row-feedbackbox' style={{ borderTop: 'none' }}>
              {
                submittedFeedbackDetails == '0' ?
                  // <div className="col-md-4">
                  //   <div className='box-feedback' >
                  //     <span className='number'>1</span><h4>Employer Feedback  </h4>
                  //     <button className='btn btn-primary' onClick={onTakeUpSurveyClick}>Take up Survey</button>
                  //   </div>
                  // </div>
                  <div class="col-md-12">
                    <button type="button" onClick={onTakeUpSurveyClick} class="btn btn-primary btn-startSurvey btn-block" >Take up Survey</button>
                  </div>
                  :
                  <div className="col-md-4">
                    <div className="box-feedback submitted">
                      <span className='status'>Submitted</span>
                      {/* <h4> Employer Feedback</h4> */}
                      <button className="btn btn-primary btn-block">Submitted</button>
                    </div>
                  </div>
              }
            </div>
          </div>
        </section>
        {/* <section className='section-footer'>
          <div className='row'><div className='col-md-12'><div className='footer col-md-6'>{config.collegeName}, Feedback System {config.version}</div>
            <div className='footer col-md-6' style={{ textAlign: 'right' }}>{config.PoweredBy}</div>
          </div></div>
        </section> */}
        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </div>
  )
}